"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var formik_1 = require("formik");
var asg_1 = require("@alinta-digital/asg");
var PaymentDetails_1 = require("../../view/PaymentDetails");
var PaymentAmount = function (props) {
    var disabled = props.disabled;
    var _a = (0, formik_1.useFormikContext)(), setFieldValue = _a.setFieldValue, initialValues = _a.initialValues;
    (0, react_1.useEffect)(function () {
        if (!initialValues.paymentDetails.paymentAmount) {
            return;
        }
        var formattedAmount = formatPaymentAmount(initialValues.paymentDetails.paymentAmount);
        var floatAmount = parseFloat(formattedAmount);
        if (isNaN(floatAmount) || floatAmount <= 0) {
            setFieldValue(PaymentDetails_1.SECTION_KEY + ".paymentAmount", '');
            return;
        }
        setFieldValue(PaymentDetails_1.SECTION_KEY + ".paymentAmount", formattedAmount);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var formatPaymentAmount = function (amount) {
        if (!amount)
            return '';
        var _a = amount.split('.'), leftValue = _a[0], rightValue = _a[1];
        var transformedLeftValue = leftValue ? leftValue : '0';
        var transformedRightValue = rightValue ? rightValue : '00';
        if (transformedRightValue.length === 1)
            transformedRightValue = transformedRightValue + "0";
        return transformedLeftValue + "." + transformedRightValue;
    };
    return (react_1.default.createElement(asg_1.Box, { margin: { top: 'medium' }, width: "100%", maxWidth: "704px" },
        react_1.default.createElement(formik_1.Field, { name: PaymentDetails_1.SECTION_KEY + ".paymentAmount", id: PaymentDetails_1.SECTION_KEY + ".paymentAmount", "data-testid": PaymentDetails_1.SECTION_KEY + "-paymentAmount", ariaRequired: true, type: "text", inputmode: "decimal", label: "Payment amount", placeholder: "Payment amount", component: asg_1.FormMaskedTextInput, color: asg_1.colors['colour-black'], textSize: "14px", options: {
                prefix: '$',
                numeral: true,
                stripLeadingZeroes: false,
                numeralThousandsGroupStyle: 'none',
                numeralDecimalMark: '.',
                numeralPositiveOnly: true
            }, onClick: function () { var _a; return (_a = props.ga) === null || _a === void 0 ? void 0 : _a.push('click.2.paymentamount'); }, disabled: disabled, onBlur: function (_a) {
                var _b, _c;
                var target = _a.target;
                var valueWithoutPrefix = target.value.slice(1);
                var formattedAmount = formatPaymentAmount(valueWithoutPrefix);
                setFieldValue(PaymentDetails_1.SECTION_KEY + ".paymentAmount", formattedAmount);
                if (((_b = props.ga) === null || _b === void 0 ? void 0 : _b.eventName) === 'process.payment') {
                    (_c = props.ga) === null || _c === void 0 ? void 0 : _c.push('click.2.paymentamount');
                }
            } })));
};
exports.default = PaymentAmount;
//# sourceMappingURL=PaymentAmount.js.map